import { Fouls, FoulsByPeriod } from 'modules/overlay-v2/domain/interfaces/game-info/state';

import supabase from '../../../core/supabase/supabase';

export async function getFouls(matchId: number): Promise<FoulsByPeriod> {
  const data = await supabase.matchChronology.getRow(matchId);
  if (!data) return {};

  const chronology = data.chronology;
  const fouls: FoulsByPeriod = {};

  for (const receivedEvent of chronology ?? []) {
    if (receivedEvent.type === 'FOUL') {
      const period = receivedEvent.period;

      if (!fouls[period]) {
        fouls[period] = { first: 0, second: 0 };
      }

      if (receivedEvent.teamId === data.firstTeamId) {
        fouls[period].first += 1;
      } else {
        fouls[period].second += 1;
      }
    }
  }

  return fouls;
}

export async function getFoulsByPeriod(matchId: number, period: number): Promise<Fouls> {
  const data = await supabase.matchChronology.getRow(matchId);
  if (!data) return { first: 0, second: 0 };

  const chronology = data.chronology;
  let fouls: Fouls = { first: 0, second: 0 };

  for (const receivedEvent of chronology ?? []) {
    if (receivedEvent.type === 'FOUL' && receivedEvent.period === period) {
      if (receivedEvent.teamId === data.firstTeamId) {
        fouls.first += 1;
      } else {
        fouls.second += 1;
      }
    }
  }

  return fouls;
}
